export const PROJECT_STATUSES = [
  "Requested",
  "Contacted",
  "Scheduled",
  "Production",
  "Delivered",
];

export const DASHBOARD_CARD_STATUSES = ["Requested", "Scheduled", "Production", "Delivered"];

export const STATUS_TONE = {
  Requested: "rgba(0, 0, 0, 1)",
  Contacted: "rgba(156, 163, 175, 0.8)",
  Scheduled: "rgba(235, 4, 13, 0.5)",
  Production: "rgba(235, 4, 13, 0.7)",
  Delivered: "rgba(235, 4, 13, 0.9)",
};

export const normalizeProjectStatus = (status) => {
  const value = String(status || "").trim();
  if (!value) return "";
  const lower = value.toLowerCase();

  if (lower === "in production") return "Production";
  if (
    lower === "aircraft poc contacted" ||
    lower === "poc contacted" ||
    lower === "contacted" ||
    lower === "in contact" ||
    lower === "aircraft poc in contact"
  ) {
    return "Contacted";
  }

  return value;
};

export const toProjectStatusDbValue = (status) => {
  return normalizeProjectStatus(status);
};

export const getStatusSortIndex = (status) => {
  const index = PROJECT_STATUSES.indexOf(normalizeProjectStatus(status));
  return index === -1 ? PROJECT_STATUSES.length : index;
};
